import { flow } from 'lodash'
import ContentCopyIcon from 'mdi-react/ContentCopyIcon'
import React, { useMemo } from 'react'
import { Column } from 'react-table'

import { Button, ButtonGroup, useMediaQuery, useTheme } from '@mui/material'

import { history } from '../../../../../../duck/store'
import { ScoutingCampaign } from '../../../../../../entities-next/scoutingCampaign'
import { insertIf } from '../../../../../../utils-next/arrays'
import { getCorporateDetailsPath } from '../../../CorporateManager'

export function useScoutingCampaignDataRows(extraRows: Column<ScoutingCampaign>[]): Column<ScoutingCampaign>[] {
  const theme = useTheme()
  const mediumScreenSize = useMediaQuery(theme.breakpoints.up('sm'))
  const largeScreenSize = useMediaQuery(theme.breakpoints.up('lg'))

  return useMemo(() => [...baseUserRowData(), ...insertIf(largeScreenSize, extraRowData()), ...extraRows], [
    theme,
    extraRows,
    largeScreenSize,
    mediumScreenSize,
  ]) as any
}

const baseUserRowData = () => [
  {
    Header: 'Id',
    accessor: getScoutingCampaignId,
    maxWidth: 28,
  },
  {
    Header: 'Name',
    accessor: flow(getScoutingCampaignName),
    maxWidth: 256,
  },
  {
    Header: 'Is Deleted',
    accessor: flow(getIsDeleted),
    maxWidth: 32,
  },
  {
    Header: 'Status',
    accessor: flow(getStatus),
    maxWidth: 32,
  },
]
const extraRowData = () => [
  {
    Header: 'Corporate',
    accessor: getCorporateId,
    maxWidth: 32,
  },
]

function getScoutingCampaignId({ id }: ScoutingCampaign) {
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigator.clipboard.writeText(id.toString())
    e.stopPropagation()
  }
  return (
    <ButtonGroup variant="contained" aria-label="outlined primary button group">
      <Button variant="contained" size="small" color="info" title="Go to details">
        {id}
      </Button>
      <Button color="info" size="small" onClick={handleCopy} title="Copy id to clipboard">
        <ContentCopyIcon size={16} />
      </Button>
    </ButtonGroup>
  )
}

function getScoutingCampaignName({ name }: ScoutingCampaign) {
  return name
}

function getCorporateId({ corporateId }: ScoutingCampaign) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    history.push(getCorporateDetailsPath(corporateId))
    e.stopPropagation()
  }
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigator.clipboard.writeText(corporateId.toString())
    e.stopPropagation()
  }

  return (
    <ButtonGroup variant="contained" aria-label="outlined primary button group">
      <Button variant="contained" size="small" color="info" onClick={handleClick} title="Go to corporate details">
        {corporateId}
      </Button>
      <Button color="info" size="small" onClick={handleCopy} title="Copy corporate id to clipboard">
        <ContentCopyIcon size={16} />
      </Button>
    </ButtonGroup>
  )
}

function getIsDeleted({ isDeleted }: ScoutingCampaign) {
  return isDeleted.toString()
}

function getStatus({ status }: ScoutingCampaign) {
  return status.charAt(0).toUpperCase() + status.slice(1)
}
